<template>
  <div> 
    <v-combobox
        v-model.trim="filtroestudiante"
        :items="estudiantes"
        label="Cuenta Netsuite"
        item-text="texto"
        :loading="isloadingestudent"
        loader-height="4"
        placeholder="tecla enter para buscar..."
        hide-details
        outlined
        dense
    />
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    props:{
      defecto:{type:Object, required:false, default:()=>{}}, 
    },
    data: () => ({
        filtroestudiante: '',
        timeoutHnd: 0,
        estudiantes: [],
        isloadingestudent: false,
    }),
    watch: {
      filtroestudiante: function() {
        if (typeof this.filtroestudiante != 'string') { 
          this.$emit('onselect', this.filtroestudiante);
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.asyncfindestudiante(vue.filtroestudiante);
          } else {
            vue.msg = '';
          }
          this.timeoutHnd = 0;
        }, 500);
      },  
    },
    methods: {
        async asyncfindestudiante(filtro) {
        this.isloadingestudent = true;
        this.filtroprograma = null;
        this.estudiantes = []; 

        window.console.log(filtro);
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/netsuitecuentas?numero=${filtro}&cuenta=${filtro}`
        let res = await xaxios.get(url).then(({ data }) => data).catch((error) => error);
        let cuentas = [];
        if (res.data) {
          cuentas = res.data;
          cuentas.map((cuenta) => {
            cuenta.texto = `${cuenta.cuenta} (${cuenta.numero})`;
          });
        }
        // window.console.log(cuentas);
        this.estudiantes = cuentas;
        this.isloadingestudent = false;
        
      }, 

      reset(valor){
        this.estudiantes = [];
        this.filtroestudiante = '';
        if(valor){
          // window.console.log('reset', valor);
          valor.texto = `${valor.cuenta} (${valor.numero})`
          this.estudiantes.push(valor);
          this.filtroestudiante = this.estudiantes[0];
        }
      },

      getSelected(){
        if (typeof this.filtroestudiante == 'string') {
          return null;
        }
        return this.filtroestudiante;
      },

      lis(){ 
        if(!this.defecto) return; 
        this.estudiantes = [];
        this.estudiantes.push( JSON.parse(JSON.stringify(this.defecto)) );
        this.filtroestudiante = this.estudiantes[0]; 
      }
    },
    mounted(){
      window.console.log('HOLISSSSS');
      setTimeout(this.lis, 500)
    }
  };
</script>
